// extracted by mini-css-extract-plugin
export default {"BookmarkletButton":"BookmarkButton-styles__BookmarkletButton__dtPBO","HeartIcon":"BookmarkButton-styles__HeartIcon__w8a73"};